import React from 'react';
import { useState, useContext } from "react";
import { useParams } from "react-router-dom";
import AlertContext from '../../Context/Alert/AlertContext';
import SocketContext from '../../Context/Socket/SocketContext'

const DeliverPopup = ({ setIsPopupVisible }) => {
    const socketcontext = useContext(SocketContext);
    const { OnlineUsers, SocetConnection, isUserOnline, setSocetConnection } = socketcontext;


    const { sentid } = useParams()
    const [loading, setLoading] = useState(false);
    const { showAlert } = useContext(AlertContext);

    const closePopup = () => {
        setIsPopupVisible(false);
    };

    const delivered = () => {
        // Update the status of the offer to deliver
        setLoading(true);
        if (SocetConnection) {
            SocetConnection.emit('updateStatus', {
                status: 'Delivered',
                offerId: sentid
            });
        }
        else console.log("Socket Connection does not exist")
        closePopup();
        showAlert('Offer delivered successfully', 'success');

    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[9999]">
            <div className="bg-white p-4 md:p-6 rounded-lg shadow-lg w-11/12 md:w-2/3 lg:w-1/3">
                <h2 className="text-lg md:text-xl font-semibold mb-4">Delivery Confirmation</h2>
                <p className="mb-6 text-sm md:text-base">Are you sure you want to deliver this item now?</p>
                <div className="flex justify-end gap-4">
                    <button
                        className="my-4 w-fit px-2 md:px-6 bg-green-500 hover:bg-transparent  hover:bg-white-500 font-semibold hover:text-black font-pop text-sm md:text-base py-1 md:py-2 border border-black-500 hover:border-green-500 rounded-full  text-white"
                        onClick={delivered}
                        disabled={loading}
                    >
                        {loading ? 'Loading...' : 'Yes, Deliver'}
                    </button>
                    <button
                        className="my-4 w-fit px-2 md:px-6 hover:bg-green-500 bg-white-500 font-semibold text-black font-pop text-sm md:text-base py-1 md:py-2 border border-black-500 hover:border-green-500 rounded-full  hover:text-white"
                        onClick={closePopup}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeliverPopup;
